import {createElement} from 'rlink-react';
import RoutingComponent from 'rlink-router/component';
import TwitchWidget from 'rlink-twitch/component';
import css from 'rlink-twitch/styles.less';

export default function (params, content) {
  return (<RoutingComponent title="twitch">
    <TwitchWidget key="twitch"
      channelGroups={content.twitchConfig.whitelistGroups}
      clientId={content.twitchConfig.clientId}
      showLogo
      theme={css}
      steamLinks={!(params.web)} />
  </RoutingComponent>);
}



// WEBPACK FOOTER //
// ./apps/ingame.companyofheroes.com/src/views/twitch.jsx